<template>
  <div class="background">
    <slick-carousel
      v-if="bookingDetail"
      :images="bookingDetail.imageConferenceRooms"
      class="mb-5"
    ></slick-carousel>
    <div class="booking-status mb-3">
      <booking-status :value="3" class="booking-status mb-5"></booking-status>
      <div class="booking-row row">
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
          <booking-information :value="bookingInfo"></booking-information>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
          <booking-confirm-box
            :value="bookingDetail"
            :isAddressForm="true"
          ></booking-confirm-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConferenceImages from "../components/ConferenceImages";
import BookingStatus from "../components/BookingStatus.vue";
import BookingConfirmBox from "../components/BookingConfirmBox";
import BookingDescription from "../components/BookingDescription";
import bookingInformation from "../components/bookingInformation";
import slickCarousel from "@/lib/components/slickCarousel"
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    "conference-images": ConferenceImages,
    "booking-status": BookingStatus,
    "booking-confirm-box": BookingConfirmBox,
    "booking-description": BookingDescription,
    "booking-information": bookingInformation,
    "sc-button": ScButton,
    "slick-carousel": slickCarousel
  },
  data() {
    return {
      eventBooking: {
        name: null,
        detail: null
      },
      bookingDetail: null,
      isAddressForm: false,
      bookingInfo: null
    };
  },
  computed: {},
  watch: {},
  created() {
    this.setupBooking();
  },
  methods: {
    async setupBooking() {
      const bookingDetail = await this.fetchBookingDetail();

      this.bookingDetail = bookingDetail.bookingDate;
      this.bookingInfo = bookingDetail.bookingInformation;
    },
    async fetchBookingDetail() {
      const { bookingId } = this.$route.params;

			try {
        return await baanRueJaiClient.others.conference.getConferenceBookingDetail(
          bookingId,
          "customer"
        );
			} catch (error) {
        console.error(error)
      }
		}
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.booking-row {
  min-height: 1000px;
}

.background {
  background-color: $white;
}

.booking-status {
  padding-left: 8%;
  padding-right: 8%;
  text-align: left;
}

.submit-button-box {
  text-align: center;
  padding-bottom: 15px;
}

@media screen and (max-width: $m-size) {
  .booking-status {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/Conference/pages/ConferenceBookingDetail.vue